<template>
  <div>
    <li v-show="showProperties.style" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Border Style</span>
      <div class="wf-w-1/2">
        <select v-model="style" class="wf-w-full">
          <option value="BORDER_NONE">none</option>
          <option value="BORDER_SOLID">solid</option>
          <option value="BORDER_DASHED">dashed</option>
          <option value="BORDER_DOTTED">dottted</option>
          <option value="BORDER_DOUBLE">double</option>
        </select>
      </div>
    </li>
    <li v-show="showProperties.width" v-if="style != 'BORDER_NONE'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Border Width</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="top-slider"
          v-model="width"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="widthClasses"
        ></vue-slider>
      </div>
    </li>
    <li v-show="showProperties.sides" v-if="style != 'BORDER_NONE'" class="wf-flex wf-flex-wrap wf-items-center wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Active</span>
      <span class="wf-w-1/2">
        <div class="wf-w-full wf-flex wf-justify-end">
          <div
            @click.prevent="toggleBorder('BorderSideLeftWidth')"
            :class="borderActive('BorderSideLeftWidth') ? ['wf-border-blue-200'] : ['wf-border-gray-300']"
            class="wf-cursor-pointer wf-border-b-2 wf-border-r-2 wf-border-t-2 wf-w-4 wf-h-4 "
          >
            <div
              :class="borderActive('BorderSideLeftWidth') ? ['wf-border-blue-600'] : ['wf-border-gray-500']"
              class="wf-w-full wf-h-full wf-border-l-2"
            ></div>
          </div>
          <div
            @click.prevent="toggleBorder('BorderSideTopWidth')"
            :class="borderActive('BorderSideTopWidth') ? ['wf-border-blue-200'] : ['wf-border-gray-300']"
            class="wf-ml-2 wf-cursor-pointer wf-border-b-2 wf-border-r-2 wf-border-l-2 wf-w-4 wf-h-4"
          >
            <div
              :class="borderActive('BorderSideTopWidth') ? ['wf-border-blue-600'] : ['wf-border-gray-500']"
              class="wf-w-full wf-h-full wf-border-t-2"
            ></div>
          </div>
          <div
            @click.prevent="toggleBorder('BorderSideRightWidth')"
            :class="borderActive('BorderSideRightWidth') ? ['wf-border-blue-200'] : ['wf-border-gray-300']"
            class="wf-ml-2 wf-cursor-pointer wf-border-b-2 wf-border-l-2 wf-border-t-2 wf-w-4 wf-h-4"
          >
            <div
              :class="borderActive('BorderSideRightWidth') ? ['wf-border-blue-600'] : ['wf-border-gray-500']"
              class="wf-w-full wf-h-full wf-border-r-2"
            ></div>
          </div>
          <div
            @click.prevent="toggleBorder('BorderSideBottomWidth')"
            :class="borderActive('BorderSideBottomWidth') ? ['wf-border-blue-200'] : ['wf-border-gray-300']"
            class="wf-ml-2 wf-cursor-pointer wf-border-l-2 wf-border-r-2 wf-border-t-2 wf-w-4 wf-h-4"
          >
            <div
              :class="borderActive('BorderSideBottomWidth') ? ['wf-border-blue-600'] : ['wf-border-gray-500']"
              class="wf-w-full wf-h-full wf-border-b-2"
            ></div>
          </div>
        </div>
      </span>
    </li>
    <li v-show="showProperties.color" v-if="style != 'BORDER_NONE'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide" v-text="text ? text : 'Border Color'"></span>
      <div class="wf-w-1/2 wf-flex wf-justify-end">
        <EditorPicker
          picker-classes="wf-top-0 wf-mt-8 wf-right-0"
          v-model="color"
        />
      </div>
    </li>
  </div>
</template>

<script>
  import _ from  'lodash'
  import EditorPicker from '../components/EditorPicker'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { BorderColorStyle } from '../styles/ColorStyles'
  import {
    BorderStyleClasses,
    BorderSideTopWidthClasses,
    BorderSideBottomWidthClasses,
    BorderSideLeftWidthClasses,
    BorderSideRightWidthClasses
  } from '../classes/BorderClasses'
  export default MenuStyleProperty.extend({
    components: {EditorPicker},

    computed: {
      showProperties() {
        let properties = {
          style: true,
          sides: true,
          width: true,
          color: true,
        }
        if(! this.only.length) {
          return properties
        }
        let newProperties = {}
        this.only.forEach(property => this.$set(newProperties, property, true))
        return newProperties
      },
      widthClasses() {
          return ['BORDER_THIN', 'BORDER_NORMAL', 'BORDER_BOLD', 'BORDER_BOLDER']
      },
      border0Classes() {
        return ['BORDER_TOP_0', 'BORDER_BOTTOM_0', 'BORDER_RIGHT_0', 'BORDER_LEFT_0']
      },
      borderSmallClasses() {
        return ['BORDER_TOP_THIN', 'BORDER_BOTTOM_THIN', 'BORDER_RIGHT_THIN', 'BORDER_LEFT_THIN']
      },
      borderNormalClasses() {
        return ['BORDER_TOP_NORMAL', 'BORDER_BOTTOM_NORMAL', 'BORDER_RIGHT_NORMAL', 'BORDER_LEFT_NORMAL']
      },
      borderBoldClasses() {
        return ['BORDER_TOP_BOLD', 'BORDER_BOTTOM_BOLD', 'BORDER_RIGHT_BOLD', 'BORDER_LEFT_BOLD']
      },
      borderBolderClasses() {
        return ['BORDER_TOP_BOLDER', 'BORDER_BOTTOM_BOLDER', 'BORDER_RIGHT_BOLDER', 'BORDER_LEFT_BOLDER']
      },
      sideClasses() {
        return ['BORDER_TOP', 'BORDER_RIGHT', 'BORDER_BOTTOM', 'BORDER_LEFT']
      },
      sideWidthClasses() {
        return [
          ...Object.keys(BorderSideTopWidthClasses),
          ...Object.keys(BorderSideBottomWidthClasses),
          ...Object.keys(BorderSideLeftWidthClasses),
          ...Object.keys(BorderSideRightWidthClasses),
        ]
      },
      styleClasses() {
        return Object.keys(BorderStyleClasses)
      },
      style: {
        get() {
          let currentStyle = this.elementClasses(this.classes)[this.device].find(elementClass => this.styleClasses.includes(elementClass.value))
          if (! currentStyle) {
            currentStyle = {property: 'BorderStyle', value: 'BORDER_NONE', touched: false}
            this.addToArray(this.module, [currentStyle], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentStyle.value
        },
        set: _.debounce(function (value) {
          let currentStyle = this.elementClasses(this.classes)[this.device].find(elementClass => this.styleClasses.includes(elementClass.value))
          value = {property: 'BorderStyle', value: value, touched: currentStyle.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      width: {
        get() {
          if (this.style === 'BORDER_NONE') {
            return
          }
          let sidesClasses = this.elementClasses(this.classes)[this.device].filter(deviceClass => this.sideWidthClasses.includes(deviceClass.value))
          if (! sidesClasses.length) {
            sidesClasses = [
              {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL', touched: false},
              {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL', touched: false},
              {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL', touched: false},
              {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL', touched: false},
            ]
            this.addToArray(this.module, sidesClasses, this.classes, this.device, {}, true, this.parentModule)
          }
          return this.getSidesWidth(sidesClasses)
        },
        set: _.debounce(function (value) {
          this.addToArray(this.module, this.getNewWidthSides(value), this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      color: {
        get() {
          if (this.style === 'BORDER_NONE') {
            return
          }
          let borderColor = this.elementStyles(this.styles)[this.device].find(deviceStyle => deviceStyle.property == BorderColorStyle.property)
          if (! borderColor) {
            borderColor = {...BorderColorStyle, value: '#000000', touched: false}
            this.addToArray(this.module, [borderColor], this.styles, this.device, {}, true, this.parentModule)
          }
          return borderColor.value
        },
        set(value) {
          let rgba = `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`
          let borderColor = {...BorderColorStyle, value: rgba, touched: false}
          this.addToArray(this.module, [borderColor], this.styles, this.device, {}, true, this.parentModule)
        }
      },
    },
    methods: {
      getNewWidthSides(width) {
        let sidesProperties = ['BorderSideLeftWidth', 'BorderSideRightWidth', 'BorderSideBottomWidth', 'BorderSideTopWidth']
        let sides = this.elementClasses(this.classes)[this.device].filter(deviceClass => sidesProperties.includes(deviceClass.property))
        let widths = {
          BORDER_THIN: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_THIN'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_THIN'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_THIN'},
          ],
          BORDER_NORMAL: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
          ],
          BORDER_BOLD: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLD'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_BOLD'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_BOLD'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_BOLD'},
          ],
          BORDER_BOLDER: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLDER'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_BOLDER'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_BOLDER'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_BOLDER'},
          ]
        }
        return sides.map(sideClass => {
            return {...widths[width].find(newWidthClass => newWidthClass.property == sideClass.property), touched: false}
        })
      },
      getSidesWidth(sides) {
        let sideWidthsQuantity = new Array
        sideWidthsQuantity = sides.filter(side => this.borderSmallClasses.includes(side.value) || this.border0Classes.includes(side.value))
        if (sideWidthsQuantity.length == sides.length) {
          return 'BORDER_THIN'
        }
        sideWidthsQuantity = sides.filter(side => this.borderNormalClasses.includes(side.value) || this.border0Classes.includes(side.value))
        if (sideWidthsQuantity.length == sides.length) {
          return 'BORDER_NORMAL'
        }
        sideWidthsQuantity = sides.filter(side => this.borderBoldClasses.includes(side.value) || this.border0Classes.includes(side.value))
        if (sideWidthsQuantity.length == sides.length) {
          return 'BORDER_BOLD'
        }
        sideWidthsQuantity = sides.filter(side => this.borderBolderClasses.includes(side.value) || this.border0Classes.includes(side.value))
        if (sideWidthsQuantity.length == sides.length) {
          return 'BORDER_BOLDER'
        }
        throw new Error('No width detected')
      },
      borderActive(border) {
        let sides_0 = {
          BorderSideTopWidth: 'BORDER_TOP_0',
          BorderSideBottomWidth: 'BORDER_BOTTOM_0',
          BorderSideLeftWidth: 'BORDER_LEFT_0',
          BorderSideRightWidth: 'BORDER_RIGHT_0',
        }
        return !! this.elementClasses(this.classes)[this.device].find(deviceClass => deviceClass.property === border && deviceClass.value !== sides_0[border])
      },
      toggleBorder(border) {
        let sides_0 = {
          BorderSideTopWidth: 'BORDER_TOP_0',
          BorderSideBottomWidth: 'BORDER_BOTTOM_0',
          BorderSideLeftWidth: 'BORDER_LEFT_0',
          BorderSideRightWidth: 'BORDER_RIGHT_0',
        }
        let borderExists = this.elementClasses(this.classes)[this.device].find(deviceClass => deviceClass.property === border && deviceClass.value !== sides_0[border])
        if (borderExists) {
          borderExists = {...borderExists, value: sides_0[border]}
          return this.addToArray(this.module, [borderExists], this.classes, this.device, {}, true, this.parentModule)
        }
        let widths = {
          BORDER_THIN: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_THIN'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_THIN'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_THIN'},
          ],
          BORDER_NORMAL: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LET_NORMAL'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
          ],
          BORDER_BOLD: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLD'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_BOLD'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_BOLD'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_BOLD'},
          ],
          BORDER_BOLDER: [
            {property: 'BorderSideTopWidth', value: 'BORDER_TOP_BOLDER'},
            {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_BOLDER'},
            {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_BOLDER'},
            {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_BOLDER'},
          ]
        }
        let sideConstant = {...widths[this.width].find(width => width.property == border), touched: false}
        this.addToArray(this.module, [sideConstant], this.classes, this.device, {}, true, this.parentModule)
      }
    }
  })
</script>